import { TxHash } from '@aztec/aztec.js/tx';
import { TransactionStatus } from '@train-protocol/sdk';
export async function getTransaction(node, txHash) {
    try {
        const receipt = await node.getTxReceipt(TxHash.fromString(txHash));
        if (!receipt)
            return null;
        let status;
        if (receipt.isDropped() || receipt.hasExecutionReverted()) {
            status = TransactionStatus.Failed;
        }
        else if (receipt.isMined()) {
            status = TransactionStatus.Confirmed;
        }
        else {
            status = TransactionStatus.Pending;
        }
        return {
            hash: txHash,
            status,
            blockNumber: receipt.blockNumber != null
                ? String(receipt.blockNumber)
                : undefined,
        };
    }
    catch {
        return null;
    }
}
